/*
  We do not use Class constructor because at the current time
  we are using Webpacker 3 with babel 6 which handles errors incorrectly
  without some extensions.
 */

function TableError(message) {
  Error.call(this, message)
  this.name = "TableError"
  this.message = message

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, TableError)
  } else {
    this.stack = new Error().stack
  }
}

TableError.prototype = Object.create(Error.prototype)

export default TableError
